import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from '../components/ui/button';
import FloridaLogo from './FloridaLogo';

export const Navbar = ({ onQuoteClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
  { name: 'Home', href: '#home' },
  { name: 'Services', href: '#services' },
  { name: 'About', href: '#about' },
  { name: 'Contact', href: '#contact' }];


  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ?
      'bg-white/95 backdrop-blur-md shadow-lg' :
      'bg-transparent'}`
      }>

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a
            href="#home"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection('#home');
            }}
            className="flex items-center gap-3"
            data-testid="nav-logo">

            <FloridaLogo className="h-12 w-auto" />
            <div className="hidden sm:block">
              <span className="font-heading text-xl font-bold text-slate-900 tracking-tight uppercase">
                Florida
              </span>
              <span className="block font-heading text-sm font-semibold text-orange-500 tracking-widest uppercase">
                Concrete Cutting
              </span>
            </div>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) =>
            <a
              key={link.name}
              href={link.href}
              onClick={(e) => {
                e.preventDefault();
                scrollToSection(link.href);
              }}
              data-testid={`nav-${link.name.toLowerCase()}-link`}
              className="font-medium text-slate-700 hover:text-orange-500 transition-colors duration-200">

                {link.name}
              </a>
            )}
          </div>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center gap-4">
            <a
              href="tel:+17863047898"
              className="flex items-center gap-2 text-slate-700 hover:text-orange-500 transition-colors"
              data-testid="nav-phone-link">

              <Phone className="h-4 w-4" />
              <span className="font-medium">(786) 304-7898</span>
            </a>
            <Button
              onClick={onQuoteClick}
              data-testid="nav-quote-btn"
              className="bg-orange-500 hover:bg-orange-600 text-white rounded-none px-6 py-5 font-bold uppercase tracking-wider transition-all hover:shadow-[4px_4px_0px_0px_rgba(51,65,85,1)]">

              Get a Quote
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 text-slate-700"
            data-testid="mobile-menu-btn">

            {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen &&
        <div className="md:hidden bg-white border-t border-slate-200 py-4" data-testid="mobile-menu">
            {navLinks.map((link) =>
          <a
            key={link.name}
            href={link.href}
            onClick={(e) => {
              e.preventDefault();
              scrollToSection(link.href);
            }}
            className="block py-3 px-4 font-medium text-slate-700 hover:bg-slate-50 hover:text-orange-500">

                {link.name}
              </a>
          )}
            <div className="px-4 pt-4 border-t border-slate-200 mt-4">
              <a
              href="tel:+17863047898"
              className="flex items-center gap-2 text-slate-700 py-2">

                <Phone className="h-4 w-4" />
                <span>(786) 304-7898</span>
              </a>
              <Button
              onClick={() => {
                onQuoteClick();
                setIsMobileMenuOpen(false);
              }}
              className="w-full mt-3 bg-orange-500 hover:bg-orange-600 text-white rounded-none px-6 py-4 font-bold uppercase tracking-wider">

                Get a Quote
              </Button>
            </div>
          </div>
        }
      </div>
    </nav>);

};

export default Navbar;